var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./basics-email.j2"] = require( "./basics-email.j2" );
dependencies["./basics-password.j2"] = require( "./basics-password.j2" );
dependencies["./demographics.j2"] = require( "./demographics.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/basics.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"formFocus") && !(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"personalInfoUpdatePW") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"personalInfoEdit") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editDemographics"))) {
output += "\n\n    ";
var t_1;
t_1 = "is-focused";
frame.set("formFocus", t_1, true);
if(frame.topLevel) {
context.setVariable("formFocus", t_1);
}
if(frame.topLevel) {
context.addExport("formFocus", t_1);
}
output += "\n\n";
;
}
else {
output += "\n\n    ";
var t_2;
t_2 = "";
frame.set("formFocus", t_2, true);
if(frame.topLevel) {
context.setVariable("formFocus", t_2);
}
if(frame.topLevel) {
context.addExport("formFocus", t_2);
}
output += "\n\n";
;
}
output += "\n\n\n<section class=\"c-profile__section c-profile__section--personal-information ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "formFocus"), env.opts.autoescape);
output += "\" data-qa-edit-profile-section>\n\n    <div class=\"o-row c-profile__row--space\">\n\n        <div class=\"o-column o-extra-small--12\">\n\n            ";
env.getTemplate("./basics-email.j2", false, "account/templates/partials/basics.j2", null, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
t_3.render(context.getVariables(), frame, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
output += t_4
output += "\n\n        </div>\n\n    </div>\n\n    <div class=\"o-row c-profile__row--space\">\n\n        <div class=\"o-column o-extra-small--12\">\n\n            ";
env.getTemplate("./basics-password.j2", false, "account/templates/partials/basics.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n\n        </div>\n\n    </div>\n\n    <div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12\">\n\n            ";
env.getTemplate("./demographics.j2", false, "account/templates/partials/basics.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "\n\n        </div>\n\n    \n    </div>\n\n</section>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/basics.j2"] , dependencies)